export const LAYOUT = {
  GRID: 'grid',
  LIST: 'list'
} as const;

export type Layout = (typeof LAYOUT)[keyof typeof LAYOUT];
